import { MicData } from "../../../models/microphone";

export const isMicDataValid = (data: MicData): boolean => {
  return !data.deleted && !!data.recognition.value;
};
